"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i] = arguments[_i];
    }
    if (functions.length === 0)
        throw new Error("pipe() requires at least 1 argument");
    if (functions.length === 1)
        return functions[0];
    var first = functions[0], rest = functions.slice(1);
    return rest.reduce(function (prev, next) { return function (val) { return next(prev(val)); }; }, first);
};
